'use client'

import { claimBonus } from '@/api/v2/queries/rewards'
import { formatValue } from '@/utils/formatNumber'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { toast } from '@/components/ui/toast'
import useBalance from '@/hooks/use-balance'

export default function HeaderRewardsDropdownBonusDepositClaimButton({
  amount,
}: {
  amount: number
}) {
  const queryClient = useQueryClient()
  const { increaseBalance } = useBalance()

  const { mutate, isLoading } = useMutation(
    ['claim-deposit-bonus'],
    async () => {
      const response = await claimBonus({ type: 'deposit-bonus' })

      return response
    },
    {
      onSuccess: (data) => {
        // update balance value
        increaseBalance(data.amount)
        // refectch availableBonus
        queryClient.invalidateQueries(['rewards'])

        toast.create({
          title: 'Success',
          description: `Successfully claimed ${formatValue(amount)} bonus!`,
          type: 'success',
        })
      },
      onError: (error: any) => {
        toast.create({
          title: 'Error',
          description:
            error?.response?.data?.message ?? 'Failed to claim bonus',
          type: 'error',
        })
      },
    }
  )

  const onClick = () => {
    mutate()
  }

  return (
    <button
      className='rewards-dropdown-bonus-deposit__infos__claim-btn'
      onClick={onClick}
      disabled={!amount || amount === 0 || isLoading}
    >
      CLAIM {formatValue(amount)}
    </button>
  )
}
